<template>
  <v-container fluid v-if="group">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Groupe : "{{group.parent_id?group.name:'Principale'}}"
            <v-spacer></v-spacer>
            <v-dialog v-model="editDialog" max-width="450px" v-if="group.id!=currentUser.group_id">
              <template v-slot:activator="{ on }">
                <v-btn icon fab small v-on="on">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>Modifier le groupe</v-card-title>
                <v-card-text>
                  <v-alert type="error" v-if="error">{{error}}</v-alert>
                  <v-row>
                    <v-text-field
                      v-model="group.name"
                      label="Nom"
                      hide-details="auto"
                      :rules="[mandatoryRules]"
                    ></v-text-field>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="group.canBuyCredit"
                        label="Autoriser les manager du groupe à créditer le compte ?"
                        false-value="no"
                        true-value="yes"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="editDialog=false">Annuler</v-btn>
                  <v-spacer />
                  <v-btn class="primary themed" @click="sendUpdate()">Confirmer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="deleteDialog"
              max-width="450px"
              v-if="group.id!=currentUser.group_id"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon fab small v-on="on">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>Effacer le groupe</v-card-title>
                <v-card-text>
                  <v-alert type="error" v-if="error">{{error}}</v-alert>
                  <v-row>
                    <v-col cols="12">Vous êtes sur le point d'effacer ce groupe</v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="deleteDialog=false">Annuler</v-btn>
                  <v-spacer />
                  <v-btn class="primary themed" @click="sendDelete()">Confirmer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-text>
            <user-list :groupId="groupId" :userList="group.users" @reload="reload()" />
            <group-detail
              v-for="subGroup in group.children"
              :groupId="subGroup.id"
              :key="subGroup.id"
              @reload="reload()"
            />
          </v-card-text>
          <v-card-actions>
            <add-group :groupId="groupId" @succes="addGroup($event)" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserList from "./UserList";
import AddGroup from "./AddGroup";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "GroupDetail",
  components: {
    AddGroup,
    UserList
  },
  data: () => ({
    deleteDialog: false,
    editDialog: false,
    group: null,
    error: null,
    mandatoryRules: v => !!v || "Ce champ est obligatoire"
  }),
  props: {
    groupId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser"])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("group", ["detail", "delete", "update"]),
    initialize() {
      this.detail(this.groupId).then(data => {
        this.group = data;
      });
    },
    addGroup(group) {
      this.group.children.push(group);
    },
    sendDelete() {
      this.error = null;

      this.delete(this.groupId)
        .then(() => {
          this.group = null;
          this.deleteDialog = false;
          this.error = null;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    sendUpdate() {
      this.error = null;

      this.update(this.group)
        .then(() => {
          this.editDialog = false;
          this.error = null;
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    reload() {
      this.group = null;
      this.initialize();
      this.$emit("reload");
    }
  }
};
</script>

<style>
</style>